module.exports = __webpack_public_path__ + "static/kelime_pozisyon_takip-def5b05c1f1e65c87cad29c23dd04f21.webp";